import { Grid } from '@mui/material';
import EAAccordion from '../EAAccordion';
import React, { useContext, useEffect } from 'react';
import useStyles from "../../style/js-style/containers/thirdparties/sheet/TPSheetStyle.js";
import { PrivilegeEnum, RoleBasedAccessControlContext } from '../../services/common/RolesUtils';
import PanelIndicators from '../thirdparties/PanelIndicators';

function IndicatorSection({ display, title, hasAnyOfPrivilegesOnScopedResource, indicators, bondType = "thirdparty" }) {
  const { classes } = useStyles();

  const {hasAnyOfPrivilegesOnPropertyId } = useContext(RoleBasedAccessControlContext);
  const [isExpanded, setExpanded] = React.useState(true);

  useEffect(() => {
    setExpanded(indicators?.length)
  }, [indicators]);

  return display && (
    <Grid item xs={12} className={bondType !== "dossier" && classes.tpItem} id={"indicators"}>
      <EAAccordion
        title={title}
        logo="thirdparty/indicator"
        titleNoResult
        opened={isExpanded}
      >
        { hasAnyOfPrivilegesOnScopedResource(bondType === "thirdparty" ? PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_INDICATOR : PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER_INDICATOR) &&
          <PanelIndicators
            indicators={
              bondType === "thirdparty"
                ? indicators?.filter(indicator => hasAnyOfPrivilegesOnPropertyId(indicator.calculationId, PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_INDICATOR))
                : indicators?.filter(indicator => hasAnyOfPrivilegesOnPropertyId(indicator.calculationId, PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER_INDICATOR))
            }
            bondType={bondType}
          />
        }
      </EAAccordion>
    </Grid>
  );
}

export default IndicatorSection;
